// 风险页面
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import RecordTable from './recordTable'
import RecordInfo from './recordInfo'

function RecordIndex () {
  const location = useLocation();//接受传值数据
  const navigate = useNavigate();//路由跳转
  const token = localStorage.getItem('dock_token')
  const [showMain, setShowMain] = useState(true)//展示主页
  const [tableInfo, setTableInfo] = useState({})//从table中得到的数据

  // 通过table传值获取info
  const getInfoByTable = (info) => {
    setShowMain(info.showMain)
    setTableInfo({ ...info })
  }
  //info中回调是否可见
  const getShowMain = (showMain) => {
    setShowMain(showMain)
  }

  useEffect(() => {
    setShowMain(true)
    // 常规巡检记录
    if (
      location.pathname === '/record_routine'// 常规巡检记录
      ||
      location.pathname === '/record_leak'// 高危巡检记录
      ||
      location.pathname === '/record_command_flight'// 指令飞行记录
      ||
      location.pathname === '/record_accurate'// 定点巡检记录
    ) {
      setShowMain(true)
    }
    // eslint-disable-next-line
  }, [location])
  return (
    <div>
      {/* <span style={{ color: '#fff' }}>{showMain ? `true` : `false`}</span> */}
      {
        showMain
          ? <RecordTable getInfo={getInfoByTable}></RecordTable>
          : <RecordInfo getShow={getShowMain} tableInfo={tableInfo}></RecordInfo>
        // : <div>123</div>
      }
    </div>
  )
}
export default RecordIndex